import { forwardRef } from "react";
import ApplicationSettingsForm from "../forms/application/ApplicationSettingsForm";
import Loading from "../loading/Loading";
import { useSettingsQuery } from "@/api/queries/admin/SettingsQueries";
import { useSettingsMutation } from "@/api/mutations/admin/SettingsMutations";
import { useTranslation } from "react-i18next";

const ApplicationSettingsSection = forwardRef(({ hideSubmitButton }: { hideSubmitButton?: boolean }, ref) => {
    const { t } = useTranslation();
    const { data, isLoading } = useSettingsQuery(true);
    const { mutate, error } = useSettingsMutation();

    const handleSubmit = (_data: any) => {
        mutate({ base_url: _data.base_url });
    };

    if (isLoading)
        return (
            <div>
                <Loading />
            </div>
        );

    return (
        <section className="flex flex-col gap-4">
            <div className="space-y-2">
                <h1 className="text-2xl font-semibold">{t("settings.applicationSettings.title")}</h1>
                <p className="text-gray-500">{t("settings.applicationSettings.description")}</p>
            </div>
            <div className="rounded-lg border bg-card/40 p-6">
                <ApplicationSettingsForm
                    initialData={{ base_url: data?.base_url }}
                    onSubmit={handleSubmit}
                    hideSubmitButton={hideSubmitButton}
                    ref={ref}
                    error={error?.message}
                />
            </div>
        </section>
    );
});

ApplicationSettingsSection.displayName = "ApplicationSettingsSection";

export default ApplicationSettingsSection;
